var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"id":"page-404","full-width":""}},[_c('h2',[_vm._v("Not found...")])])}
var staticRenderFns = []

export { render, staticRenderFns }